export enum FeatureToggle {
  ShoppingList = 'rt_pickup_shopping_list',
}
